<template>
    <component :is="footerComponent" />
</template>

<script setup>
    const { digistormSettings, appId } = storeToRefs(useGlobalStore())

    const preFooterType = computed(() => {
        return digistormSettings.value.preFooterType
    })

    // Import custom components
    const customComponents = await import(`~/custom/${appId.value}/index.js`)
        .catch(() => {
            return null
        })

    const footerComponent = computed(() => {
        if (customComponents?.default && preFooterType.value === 'pre-footer-custom') {
            return customComponents?.default?.PreFooter
        }

        return defineAsyncComponent(() =>
            import(`./${ digistormSettings.value.preFooterType }/pre-footer.async.vue`)
        )
    })

</script>
